var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICN_-_RESET_NORMAL",
    "data-name": "ICN - RESET NORMAL",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 32,
    height: 32,
    rx: 3,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "restart_alt_FILL0_wght400_GRAD0_opsz48",
    d: "M17.783,25.585a8.562,8.562,0,0,0,5.786-2.823,8.874,8.874,0,0,0,1.356-10.091,8.325,8.325,0,0,0-2.781-3.1l-1.2,1.2a6.415,6.415,0,0,1,2.432,2.53,7.109,7.109,0,0,1,.867,3.424A6.971,6.971,0,0,1,22.4,21.56a7.068,7.068,0,0,1-4.612,2.348Zm-1.677,0V23.908a7.124,7.124,0,0,1-4.612-2.362,6.981,6.981,0,0,1-1.817-4.822,7.206,7.206,0,0,1,7.268-7.268H17.5l-1.677,1.677,1.2,1.2,3.718-3.718L17.029,4.9l-1.2,1.2L17.5,7.779h-.559A8.609,8.609,0,0,0,10.6,10.393,8.646,8.646,0,0,0,8,16.724a8.63,8.63,0,0,0,2.334,6.038A8.51,8.51,0,0,0,16.106,25.585Z",
    transform: "translate(-0.959 0.758)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.919d9e86c517340dfced510380a7d851.svg";
export { ForwardRef as ReactComponent };